import axios from "./axios";
import { handleApiError } from "./handleApiError";

export interface AdminCommentItem {
  id: string;
  userId: string;
  username: string;
  contentId?: string;
  contentPartId?: string;
  contentTitle?: string;
  contentPartTitle?: string;
  text: string;
  createdAt: string;
  isHidden: boolean;
}

export interface CommentSearchResponse {
  items: AdminCommentItem[];
  totalCount: number;
}

export async function searchAdminComments(params: {
  username?: string;
  userId?: string;
  contentId?: string;
  contentPartId?: string;
  fromUtc?: string;
  toUtc?: string;
  isHidden?: boolean;
  skip?: number;
  take?: number;
}): Promise<CommentSearchResponse> {
  try {
    const res = await axios.get("/admin/comments", {
      params: {
        username: params.username,
        userId: params.userId,
        contentId: params.contentId,
        contentPartId: params.contentPartId,
        fromUtc: params.fromUtc,
        toUtc: params.toUtc,
        isHidden: typeof params.isHidden === "boolean" ? params.isHidden : undefined,
        skip: params.skip,
        take: params.take,
      },
    });
    if (res.data && typeof res.data === "object") {
      return {
        items: Array.isArray(res.data.items) ? (res.data.items as AdminCommentItem[]) : [],
        totalCount: Number(res.data.totalCount ?? 0),
      };
    }
    return { items: [], totalCount: 0 };
  } catch (error) {
    return handleApiError(error, "searchAdminComments", { items: [], totalCount: 0 });
  }
}

export async function hideAdminComment(commentId: string): Promise<boolean> {
  try {
    await axios.post("/admin/comments/hide", { commentId });
    return true;
  } catch (error) {
    return handleApiError(error, "hideAdminComment", false);
  }
}

export async function unhideAdminComment(commentId: string): Promise<boolean> {
  try {
    await axios.post("/admin/comments/unhide", { commentId });
    return true;
  } catch (error) {
    return handleApiError(error, "unhideAdminComment", false);
  }
}

export async function deleteAdminComment(commentId: string): Promise<boolean> {
  try {
    await axios.post("/admin/comments/delete", { commentId });
    return true;
  } catch (error) {
    return handleApiError(error, "deleteAdminComment", false);
  }
}

export async function hideAdminCommentsBulk(commentIds: string[], reason?: string): Promise<boolean> {
  try {
    await axios.post("/admin/comments/hide/bulk", { commentIds, reason });
    return true;
  } catch (error) {
    return handleApiError(error, "hideAdminCommentsBulk", false);
  }
}

export async function unhideAdminCommentsBulk(commentIds: string[], reason?: string): Promise<boolean> {
  try {
    await axios.post("/admin/comments/unhide/bulk", { commentIds, reason });
    return true;
  } catch (error) {
    return handleApiError(error, "unhideAdminCommentsBulk", false);
  }
}

export async function deleteAdminCommentsBulk(commentIds: string[], reason?: string): Promise<boolean> {
  try {
    await axios.post("/admin/comments/delete/bulk", { commentIds, reason });
    return true;
  } catch (error) {
    return handleApiError(error, "deleteAdminCommentsBulk", false);
  }
}
